import { ApiInstance } from '@src/services/api-instance';
import { HubV1Service } from './modules/v1/hub-api-v1';

export class HubApi {
  private client: ApiInstance;

  public v1: HubV1Service;

  constructor(client?: ApiInstance) {
    this.client = client || new ApiInstance(import.meta.env.VITE_HUB_BASE_URL, 30000);

    this.v1 = new HubV1Service(this.client);
  }
}
